import type { TradingPositionsSort } from "@tradingApp/components/Trading/Positions/SortBy";
import type { ClearinghouseState } from "hyperliquid";

export function tradingPositionsSort(
  positions: ClearinghouseState["assetPositions"] | null,
  field: TradingPositionsSort["field"],
  dir: "asc" | "desc",
): ClearinghouseState["assetPositions"] {
  if (!Array.isArray(positions)) {
    return [];
  }

  let positionsSorted: ClearinghouseState["assetPositions"];

  switch (field) {
    case "positionValue":
      positionsSorted = sortBy(positions, "positionValue");
      break;
    case "unrealizedPNL":
      positionsSorted = sortBy(positions, "unrealizedPnl");
      break;
    case "leverage":
      positionsSorted = sortByLeverage(positions);
      break;
    default:
      positionsSorted = sortBy(positions, "positionValue");
  }

  if (dir === "asc") {
    positionsSorted = [...positionsSorted].reverse();
  }

  return positionsSorted;
}

function sortBy(
  positions: ClearinghouseState["assetPositions"],
  key: "positionValue" | "unrealizedPnl",
): ClearinghouseState["assetPositions"] {
  return [...positions].sort((a, b) => {
    const aValue = Number(a?.position?.[key]);
    const bValue = Number(b?.position?.[key]);

    return bValue - aValue;
  });
}

function sortByLeverage(
  positions: ClearinghouseState["assetPositions"],
): ClearinghouseState["assetPositions"] {
  return [...positions].sort((a, b) => {
    const aValue = Number(a?.position?.leverage?.value);
    const bValue = Number(b?.position?.leverage?.value);

    return bValue - aValue;
  });
}
